import { datadogRum } from "@datadog/browser-rum";
import { useQuery } from "react-query";

import { getAppVersion } from "api/getAppVersion";

const refreshCacheAndReload = async () => {
  if (caches) {
    const cacheKeys = await caches.keys();

    await Promise.all(cacheKeys.map((key) => caches.delete(key)));
    window.location.reload();
  }
};

export const useCacheBuster = () => {
  const isProductionWithServiceWorkers = process.env.NODE_ENV === "production" && "serviceWorker" in navigator;
  const localAppVersion = process.env.REACT_APP_VERSION;

  useQuery("fetchAppVersion", () => getAppVersion(), {
    enabled: navigator.onLine && isProductionWithServiceWorkers,
    onSuccess: ({ version }) => {
      if (version !== localAppVersion) {
        console.log(`There is a new app version - ${version}. Deleting cache and refreshing the app`);
        refreshCacheAndReload();
      }
    },
    onError: (error) => {
      datadogRum.addError(error, {
        message: "Failed to get app version",
      });
    },
  });
};
